// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1zFQ4","search":"Settings_search__d4lFO","filter":"Settings_filter__3g1uP"};